let refreshPromise: Promise<{
  result: boolean;
  data?: { access_token?: string };
  message?: string[];
} | undefined> | null = null;

export function getRefreshPromise() {
  return refreshPromise;
}

export function setRefreshPromise(
  promise: typeof refreshPromise,
) {
  refreshPromise = promise;
}

export function clearRefreshPromise() {
  refreshPromise = null;
}
